import { render, staticRenderFns } from "./drug.vue?vue&type=template&id=3f61f80e&scoped=true"
import script from "./drug.vue?vue&type=script&lang=js"
export * from "./drug.vue?vue&type=script&lang=js"
import style0 from "./drug.vue?vue&type=style&index=0&id=3f61f80e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f61f80e",
  null
  
)

export default component.exports